module.exports = __webpack_public_path__ + "media/default-events.09d7392b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/default-events.svg
// module id = 534
// module chunks = 58